import { post, get, createApiUrl } from './baseApi';

// 대시보드
export function getDashboard(params) {
    const request = createApiUrl("/api/v1/admin/dashboard/summary");
    return post(request, params);
}

export function getHeader(params) {
    const request = createApiUrl("/api/v1/admin/dashboard");
    return post(request, params);
}

// 통계 정보
export function getUserStatistics(params) {
    const request = createApiUrl("/api/v1/admin/report/user/statistics");
    return post(request, params);
}

export function getGameStatistics(params) {
    const request = createApiUrl("/api/v1/admin/report/game/statistics");
    return post(request, params);
}

export function getDailyStatistics(params) {
    const request = createApiUrl("/api/v1/admin/report/daily/statistics");
    return post(request, params);
}

export function getHourlyGameStatistics(params) {
    const request = createApiUrl("/api/v1/admin/report/hourly/game-statistics");
    return post(request, params);
}

// 출석현황
export function getAttendancePivot(params) {
    const request = createApiUrl("/api/v1/admin/attendance/pivot");
    return get(request, params);
}
